import React from 'react';
import Layout from './layout';
import { useTranslation } from 'react-i18next';

const Safety = () => {
    const { t } = useTranslation();

    return (
        <Layout selected="about">
            <div className="container min-vh-100">
                <h1>{t('safety-title')}</h1>

                <p>{t('safety-intro')}</p>

                <h4>{t('safety-confidence-heading')}</h4>
                <p>
                    <b>{t('safety-social-title')}</b> {t('safety-social-text')}
                </p>

                <p>
                    <b>{t('safety-communication-title')}</b> {t('safety-communication-text')}
                </p>

                <h4>{t('safety-meeting-heading')}</h4>
                <p>
                    <b>{t('safety-public-title')}</b> {t('safety-public-text')}
                </p>
                <p>
                    <b>{t('safety-locale-title')}</b> {t('safety-locale-text')}
                </p>
                <p>
                    <b>{t('safety-sober-title')}</b> {t('safety-sober-text')}
                </p>

                <h4>{t('safety-emergency-heading')}</h4>
                <p>
                    <b>{t('safety-emergency-title')}</b> {t('safety-emergency-text')}
                </p>
                <p>
                    <b>{t('safety-instincts-title')}</b> {t('safety-instincts-text')}
                </p>

                <h4>{t('safety-after-heading')}</h4>
                <p>
                    <b>{t('safety-feedback-title')}</b> {t('safety-feedback-text')}
                </p>

                <p className="mt-3">{t('safety-closing')}</p>
            </div>
        </Layout>
    );
}

export default Safety;
